module.exports = __webpack_public_path__ + "media/18a.ff10763f.mp4";